import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./Login";
import Dashboard from "./Dashboard";
import LeaveDashboard from "./leaveDashboard";
import BatteryDashboard from "./BatteryDashboard";
import OvertimeDashboard from "./driverOvertime";
import OvertimeAllocation from "./overtimeDashboard";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/leaveDashboard" element={<LeaveDashboard />} />
        <Route path="/charge" element={<BatteryDashboard />} />
        <Route path="/overtime" element={<OvertimeDashboard />} />
        <Route path="/overtimeAllocation" element={<OvertimeAllocation />} />
      </Routes>
    </Router>
  );
}

export default App;
